import { render, staticRenderFns } from "./office_box.vue?vue&type=template&id=13404855&scoped=true"
import script from "./office_box.vue?vue&type=script&lang=js"
export * from "./office_box.vue?vue&type=script&lang=js"
import style0 from "./office_box.vue?vue&type=style&index=0&id=13404855&prod&scoped=true&lang=less"
import style1 from "./office_box.vue?vue&type=style&index=1&id=13404855&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13404855",
  null
  
)

export default component.exports